import React from "react"
import FuncOpenCloudProviderModal from "~/components/api/functions/FuncOpenCloudProviderModal"
import { isBrowser } from "~/services/Utils"
import FuncAddProductToCart from "./functions/FuncAddProductToCart"
import FuncGetPageProducts from "./functions/FuncGetPageProducts"
import FuncIsPageReady from "./functions/FuncIsPageReady"
import FuncScrollToNextActionableBlock from "./functions/FuncScrollToNextActionableBlock"
import FuncUploadImages from "./functions/FuncUploadImages"

interface Props {}

const GlobalFunctions: React.FC<Props> = () => {
  if (!isBrowser) {
    return null
  }

  return (
    <>
      <FuncAddProductToCart />
      <FuncScrollToNextActionableBlock />
      <FuncIsPageReady />
      <FuncGetPageProducts />
      <FuncUploadImages />
      <FuncOpenCloudProviderModal />
    </>
  )
}

export default GlobalFunctions
